import React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { pickRandomly } from "../../util/utilityFunctions";

import bronze from "./visual/border-bronze-OberionIO.min.svg";
import silver from "./visual/border-silver-OberionIO.min.svg";
import gold from "./visual/border-gold-OberionIO.min.svg";

import badge01 from "./visual/badge-claimant-OberionIO.min.svg";
import badge02 from "./visual/badge-connected-steam-account-OberionIO.min.svg";
import badge03 from "./visual/badge-early-bird-OberionIO.min.svg";
import badge04 from "./visual/badge-first-discovery-tour-OberionIO.min.svg";
import badge05 from "./visual/badge-good-game-OberionIO.min.svg";
import badge06 from "./visual/badge-indie-OberionIO.min.svg";
import badge07 from "./visual/badge-lets-be-friends-OberionIO.min.svg";
import badge08 from "./visual/badge-occasionally-play-video-games-OberionIO.min.svg";
import badge09 from "./visual/badge-patron-OberionIO.min.svg";
import badge10 from "./visual/badge-pro-gamer-OberionIO.min.svg";
import badge11 from "./visual/badge-yearling-1-OberionIO.min.svg";
import badge12 from "./visual/badge-yearling-2-OberionIO.min.svg";
import badge13 from "./visual/badge-yearling-3-OberionIO.min.svg";
import badge14 from "./visual/badge-yearling-4-OberionIO.min.svg";
import badge15 from "./visual/badge-yearling-5-OberionIO.min.svg";


const allBadges = [badge01, badge02, badge03, badge04, badge05, badge06, badge07, badge08, badge09, badge10, badge11, badge12, badge13, badge14, badge15];


const badgeSize = "5rem";

const BadgeCircle = styled.div`
    background-size: ${badgeSize};
    width: ${badgeSize};
    height: ${badgeSize};
    
    margin-bottom: 1rem;
`;
const BadgeBronze = styled(BadgeCircle)` background-image: url(${bronze}) `;
const BadgeSilver = styled(BadgeCircle)` background-image: url(${silver}) `;
const BadgeGold = styled(BadgeCircle)` background-image: url(${gold}) `;
const allOutlines = [
  ["bronze", BadgeBronze],
  ["silver", BadgeSilver],
  ["gold", BadgeGold],
];


const BadgeContent = styled.img`
    padding: 0.4rem;
    max-width: ${badgeSize};
    height: auto;
    box-sizing: border-box;
    border-radius: 50%;
`;

const BadgeSupplier = ({ caption, outline }) => {
  let badge = pickRandomly(allBadges);
  if (caption === "Early Bird") {
    badge = badge03;
  } else if (caption === "Connected Steam account") {
    badge = badge02;
  }

  let BadgeOutline = pickRandomly(allOutlines);
  if (outline === "bronze") {
    BadgeOutline = BadgeBronze;
  } else if (outline === "silver") {
    BadgeOutline = BadgeSilver;
  } else if (outline === "gold") {
    BadgeOutline = BadgeGold;
  }

  return (
    <BadgeOutline>
      <BadgeContent src={badge} alt="badge description" />
    </BadgeOutline>
  );
};

BadgeSupplier.propTypes = {
  caption: PropTypes.string.isRequired,
  outline: PropTypes.string.isRequired,
};

export default BadgeSupplier;